import type { ReactNode } from 'react';

export interface SectionCardProps {
  /** Título do card (texto do header). */
  readonly title: ReactNode;
  /** Ícone opcional à esquerda do título. */
  readonly icon?: ReactNode;
  /** Conteúdo do canto direito do header (meta, contagem ou ações). */
  readonly headerRight?: ReactNode;
  /** Conteúdo do corpo do card. O padding é responsabilidade do conteúdo. */
  readonly children?: ReactNode;
  readonly className?: string;
}

/**
 * Card de seção padrão: header com `border-b-hairline` + corpo, sobre superfície com
 * sombra nível 1. O corpo recebe os filhos sem padding — quem usa define o espaçamento
 * interno (alguns cards têm seções full-bleed, como a tabela de vínculos).
 */
export function SectionCard({ title, icon, headerRight, children, className }: SectionCardProps) {
  return (
    <section
      className={[
        'overflow-hidden rounded-md border-hairline border-ctx-layout-border bg-ctx-layout-surface shadow-level1',
        className ?? '',
      ].join(' ')}
    >
      <div className="flex items-center justify-between gap-xxs border-b-hairline border-ctx-layout-border px-xxxs py-mini">
        <div className="flex items-center gap-nano text-ctx-content-title ts-heading-xxs">
          {icon}
          {title}
        </div>
        {headerRight ? <div className="shrink-0">{headerRight}</div> : null}
      </div>
      {children}
    </section>
  );
}
